import Home from '@/components/index'//首页

// import CloudStory from '@/components/column/cloudstorys'//领域架构
// import StoryContainer from '@/components/column/cloudstorys/storycontainer'

// import Special from '@/components/column/special'//开发中心
// import Structure from '@/components/column/specials/structure'
// import Field from '@/components/column/specials/field'
// import Process from '@/components/column/specials/process'
// import Hardware from '@/components/column/specials/hardware'

// import TimeMachine from '@/components/column/timemachine'//留住时光

import yyds from '@/components/user/tohome/yyds' //用户页面
import Userindex from '@/components/user/userindex' //用户页面
import Usermessage from '@/components/user/usercolumn/message'//用户信息

import sort from '@/components/user/usercolumn/sort/sort'//用户专栏
import UserStory from '@/components/user/usercolumn/sort/story'//用户专栏
import addstory from '@/components/user/usercolumn/sort/addstory' //添加专栏
import updatastory from '@/components/user/usercolumn/sort/updatastory' //修改专栏

import UserPI from '@/components/user/usercolumn/pi/pi'  //个人资料
import uppi from '@/components/user/usercolumn/pi/uppi'  //修改资料

import accountmessage from '@/components/user/usercolumn/account/accountmessage' //账号信息
import accountsettings from '@/components/user/usercolumn/account/accountsettings'  //账号设置
import privacy from '@/components/user/usercolumn/privacy'  //隐私设置

import release from '@/components/user/usercolumn/release/release'  //发布管理
import telegraphs from '@/components/user/usercolumn/release/telegraphs/telegraphs'  //内容列表
import send from '@/components/user/usercolumn/release/send'  //添加发布
import draft from '@/components/user/usercolumn/release/draft'  //草稿列表


import clientmessage from '@/components/user/usercolumn/clientmessage'  //站内信息
import supermessage from '@/components/user/usercolumn/supermessage'  //系统信息
import privatemessage from '@/components/user/usercolumn/privatemessage'  //私信信息





import AboutOOPVR from '@/components/column/aboutoopvr'//关于
import Aboutconfig from '@/components/bottonconfig/aboutconfig'//关于本站
import Exemptionconfig from '@/components/bottonconfig/exemptionconfig'//免责声明
import Privacyconfig from '@/components/bottonconfig/privacyconfig'//隐私政策


/**
 * 基础路由
 */
export let constantRouterMap = [

  {//首页
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      title: '关于本站'
    }
  },
  //   {//开发中心
  //     path: '/Special',
  //     name: 'Special',
  //     component: Special,
  //     children: [
  //       {
  //         path: 'Structure',
  //         name: 'Structure',
  //         component: Structure
  //       },
  //       {
  //         path: 'Field',
  //         name: 'Field',
  //         component: Field
  //       },
  //       {
  //         path: 'Process',
  //         name: 'Process',
  //         component: Process
  //       },
  //       {
  //         path: 'Hardware',
  //         name: Hardware,
  //         component: Hardware
  //       },
  //     ]
  //   },
  //   {//故事云村
  //     path: '/CloudStory',
  //     name: 'CloudStory',
  //     redirect: "/CloudStory/",  //重定向到第一个子路由
  //     component: CloudStory,
  //     children: [{
  //       path: '/',
  //       name: 'StoryContainer',
  //       component: StoryContainer
  //     },

  //     ]
  //   },
  //   {//留住时光
  //     path: '/TimeMachine',
  //     name: 'TimeMachine',
  //     component: TimeMachine
  //   },

  {
    path: '/yyds',
    name: 'yyds',
    component: yyds,
    meta: {
      title: 'yyds'
    }
  },
  {//用户
    path: '/User',
    name: 'User',
    component: Userindex,
    redirect: "/User/index",  //重定向到第一个子路由
    meta: {
      isLogin: true,
    },
    children: [{
      path: 'index',
      name: 'UserMessage',
      component: Usermessage,
      meta: {
        title: "个人首页"
      }
    },
    {
      path: '/User/sort',
      name: 'sort',
      component: sort,
      redirect: '/User/sort/storys',
      meta: {
        title: "专栏管理"
      },
      children: [
        {
          path: '/User/sort/storys',
          name: 'UserStory',
          component: UserStory,
          meta: {
            title: "专栏列表"
          },
        },
        {
          path: '/User/sort/addstory',
          name: 'addstory',
          component: addstory,
          meta: {
            title: "添加专栏"
          }
        },
        {
          path: '/User/sort/updatastory/:data',
          name: 'updatastory',
          component: updatastory,
          meta: {
            title: "编辑专栏"
          }
        },
      ]
    },

    {
      path: 'pi',
      name: 'pi',
      component: UserPI,
      meta: {
        title: "个人资料"
      }
    },
    {
      path: 'uppi',
      name: 'uppi',
      component: uppi,
      meta: {
        title: "修改个人资料"
      }
    },


    {
      path: '/User/accountmessage',
      name: 'accountmessage',
      component: accountmessage,
      meta: {
        title: "账号信息"
      },
      redirect: '/User/accountmessage/accountsettings',
      children: [
        {
          path: '/User/accountmessage/accountsettings',
          name: 'accountsettings',
          component: accountsettings,
          meta: {
            title: "账号设置"
          }
        },
      ]
    },



    {
      path: 'privacy',
      name: 'privacy',
      component: privacy,
      meta: {
        title: "隐私设置"
      }
    },


    {
      path: '/User/release',
      name: 'release',
      component: release,
      redirect: '/User/release/telegraphs',
      meta: {
        title: "发布管理"
      },
      children: [
        {
          path: '/User/release/telegraphs',
          name: 'telegraphs',
          component: telegraphs,
          meta: {
            title: "发布列表"
          }
        },

        {
          path: '/User/release/send',
          name: 'send',
          component: send,
          meta: {
            title: "添加发布"
          }
        },
        {
          path: '/User/release/draft',
          name: 'draft',
          component: draft,
          meta: {
            title: "草稿列表"
          }
        },
      ]
    },

    {
      path: 'clientmessage',
      name: 'clientmessage',
      component: clientmessage,
      meta: {
        title: "站内信息"
      }
    },
    {
      path: 'supermessage',
      name: 'supermessage',
      component: supermessage,
      meta: {
        title: "系统消息"
      }
    },
    {
      path: 'privatemessage',
      name: 'privatemessage',
      component: privatemessage,
      meta: {
        title: "私信信息"
      }
    },
    ]
  },
  {//关于
    path: '/AboutOOPVR',
    name: 'AboutOOPVR',
    component: AboutOOPVR
  },
  {//关于本站组件
    path: '/Aboutconfig',
    name: 'Aboutconfig',
    component: Aboutconfig,
    meta: {
      title: '关于本站'
    }
  },
  {//免责声明组件
    path: '/Exemptionconfig',
    name: 'Exemptionconfig',
    component: Exemptionconfig,
    meta: {
      title: '免责声明'
    }
  },
  {//隐私策略组件
    path: '/Privacyconfig',
    name: 'Privacyconfig',
    component: Privacyconfig,
    meta: {
      title: '隐私策略'
    }
  }

];



export function getAsyncRoutes(routes) {
  const res = []
  // 定义路由中需要的自定名
  // const keys = ['path', 'name', 'children', 'redirect', 'meta', 'hidden']
  // 遍历路由数组去重组可用的路由
  routes.forEach(item => {
    const newItem = {};
    newItem.path = item.sortUrl;
    newItem.name = item.sortAlias;
    newItem.redirect = item.sortRedirect
    newItem.meta = { title: item.sortName, sortCode: item.sortCode, sortKeyWord: item.sortKeyWord, sortDescribe: item.sortDescribe, disabled: item.disabled };
    // newItem.component = resolve => require([`@${item.sortPosition}`],resolve) /components/
    newItem.component = resolve => require([`@/components/${item.sortPosition}.vue`], resolve)
    // 此处用reqiure比较好，import引入变量会有各种莫名的错误
    // newItem.component = (() => import(`@${item.sortPosition}`));
    if (item.hasOwnProperty("children") && item.children.length > 0) {
      newItem.children = getAsyncRoutes(item.children)
    }
    res.push(newItem)
  })
  // 返回处理好且可用的路由数组
  return res
}



// WEBPACK FOOTER //
// ./src/router/initroute.js